import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSymantecComponent } from './simple-icons-symantec.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSymantecComponent ],
    exports:      [ SimpleIconsSymantecComponent ],
    bootstrap:    []
})
export class SimpleIconsSymantecModule {}
